module.exports = {
	namespaced: true,
	state: require('./state'),
	getters: require('./getters'),
	mutations: require('./mutations'),
	actions: require('./actions'),
}